<template>
  <div>
    <md-dialog-confirm
      :md-title="title"
      :md-active.sync="showDialog"
      :md-click-outside-to-close="false"
      :md-content="content"
      :md-confirm-text="confirmText"
      :md-cancel-text="cancelText"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"
      @md-opened="setLayerDialog"
    />
  </div>
</template>

<script>
export default {
  name: "dialog-confirm",

  props: {
    show: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    content: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      required: true
    },
    cancelText: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      showDialog: false
    };
  },

  watch: {
    show() {
      if (this.show) {
        this.showDialog = this.show;
      }
    }
  },

  methods: {
    setLayerDialog() {
      if (document.getElementsByClassName("md-dialog").length > 1) {
        var x = document.getElementsByClassName("md-dialog")[1];
        x.style.zIndex = 12;
        var y = document.getElementsByClassName("md-overlay")[1];
        y.style.zIndex = 11;
      }
    },
    onCancel() {
      this.$emit("cancel");
    },
    onConfirm() {
      this.$emit("confirm");
    }
  }
};
</script>